// extracted by mini-css-extract-plugin
export default {"genericAttributeContainer":"generic-attribute-container__generic-attribute-container__ykvKe"};